<template>
  <AccountOpePanel>
    <div class="card">
<!--      <div class="card-header row gutters-5">-->
<!--        <div class="col">-->
<!--          <h5 class="mb-0 h6">{{ $t("通知") }}</h5>-->
<!--        </div>-->
<!--      </div>-->
      <div class="card-body">
        <h5 class="mb-0 h6">{{ $t("通知") }}</h5>
        <messageList/>
        <!--            <ul class="list-group list-group-flush">-->
        <!--              <li class="list-group-item">-->
        <!--                <div class="py-4 text-center fs-16">-->
        <!--                  {{ $t("未找到通知") }}-->
        <!--                </div>-->
        <!--              </li>-->
        <!--            </ul>-->
      </div>
    </div>

  </AccountOpePanel>
</template>
<script>
import MessageList from "@/views/user/messageList.vue";
import AccountOpePanel from "@/components/AccountOpePanel.vue";

export default {
  name:'NotificationsView',
  components: {MessageList, AccountOpePanel},
  data() {

  },
}

</script>
